import styled from 'styled-components';
import COLORS from '../../utils/Colors';

interface PropsCustomInput {
    isFocused: boolean;
    showError: boolean;
    disabled: boolean;
    textColor?: string;
    placeHolderColor?: string;
}

interface PropsCustomView {
    bgColor: string;
}


export const CustomInput = styled.input<PropsCustomInput>`
    flex: 1;
    font-size: 1.125rem;
    padding: 0 0.65625rem;
    width: 100%;
    color:  ${props => props.textColor};
    border-radius: 12px;
    background-color: ${props => props.showError === true ? `${COLORS.hsl000100099}` : 'transparent'};
    border: ${props => props.disabled === true ? `1.5px solid ${COLORS.hsl000000083}` :
        (props.showError === true ? `1.5px solid ${COLORS.hsl003100059}` : `1.5px solid ${COLORS.hsl000000083}`)
    };

    &:focus {
        border-radius: 12px;
        outline: none;
        transition: .1s;
        box-shadow: ${props => props.showError === true ? `inset 0 0 0.3pt 0.5pt ${COLORS.hsl003100059}` : `inset 0 0 0.3pt 0.5pt ${COLORS.hsl214054043}`};
        border: ${props => props.showError === true ? `1.5px solid ${COLORS.hsl003100059}` : `1.5px solid ${COLORS.hsl214054043}`};
    }

    &::placeholder{
        color: ${({ placeHolderColor }) => placeHolderColor === '3' ? `${placeHolderColor}` : `${COLORS.hsl220003087}`};
        font-size: 1.125rem;
    }
`;

export const CustomView = styled.div<PropsCustomView>`
    display: flex;
    flex-direction: row;
    position: relative;
    border-radius: 12px;
    background-color: ${props => props.bgColor};
    height: 3.125rem;
`;

export const AlertDiv = styled.div`
   position: absolute;
   right: 15px;
   top: 15px;
`;
